import React from 'react';

import InteractiveErrorToaster from 'application/components/InteractiveErrorToaster';
import { TEXTS } from 'application/pages/texts';
import CommunicationUtils from 'application/utils/CommunicationUtils';
import { NotificationContextType } from 'application/providers/NotificationProvider/types';

import { Country } from '@shared/api/graphql/generated';

export const showCopyStreamError = (notification: NotificationContextType, country: Country) => {
  notification.showErrorNotification({
    children: (
      <InteractiveErrorToaster
        onSubmit={() => {
          CommunicationUtils.connectWithManager(country);
          notification.hideNotification();
        }}
        onClose={() => {
          notification.hideNotification();
        }}
        title={TEXTS.SET_STREAM_ERROR_TITLE}
        submitButtonTitle={TEXTS.SET_STREAM_ERROR_ACTION}
        closeButtonTitle={TEXTS.SET_STREAM_ERROR_CLOSE}
        elementId="set_stream_error"
      />
    ),
    closeAfterClick: false,
  });
};
